import { render, staticRenderFns } from "./RwRouteEdit.vue?vue&type=template&id=57d7d88f&scoped=true&"
import script from "./RwRouteEdit.vue?vue&type=script&lang=ts&"
export * from "./RwRouteEdit.vue?vue&type=script&lang=ts&"
import style0 from "./RwRouteEdit.vue?vue&type=style&index=0&id=57d7d88f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7d88f",
  null
  
)

export default component.exports